export const SET_NAME = "SET_NAME";
export const SET_EMAIL = "SET_EMAIL";
export const VALIDATION = "BUYER_VALIDATION";
